var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"df-footer"},[_c('div',{staticClass:"df-footer-content"},[_c('div',{staticClass:"df-flex df-flex-col"},[_c('div',{staticClass:"df-footer-links",domProps:{"innerHTML":_vm._s(_vm.selexFooter)}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }